/**
 * The last card Sticky chose for a cursor move in the document.
 *
 * Kept in memory only, so the dev agent bridge can check Sticky end to end:
 * it moves the cursor, waits for a decision with a newer `seq`, and compares
 * the card Sticky chose with the card the paragraph belongs to.
 */
export type StickyDecision = {
  seq: number;
  at: number;
  paragraphIndex: number | null;
  clauseId: string | null;
  clauseNumber: string | null;
  matchedBy: string;
};

let seq = 0;
let last: StickyDecision | null = null;

export function recordStickyDecision(decision: Omit<StickyDecision, 'seq' | 'at'>): void {
  seq += 1;
  last = { ...decision, seq, at: Date.now() };
}

export function getLastStickyDecision(): StickyDecision | null {
  return last;
}

/**
 * Where the list actually ended up after Sticky scrolled: the card under the
 * sticky header, and how far the chosen card's header is from that line. The
 * decision alone does not show it — the scroll can land on another card.
 */
export type StickyLanding = {
  at: number;
  msAfterScroll: number;
  targetClauseId: string;
  targetShownNumber: string | null;
  topClauseId: string | null;
  topShownNumber: string | null;
  /** Chosen card's header top minus the line under the sticky header, in px (≈0 when aligned). */
  targetOffsetPx: number | null;
  /** The list cannot scroll further down, so a card near the end cannot reach the top. */
  atScrollEnd: boolean | null;
  scrollRoot: string | null;
  scrollTop: number | null;
  maxScrollTop: number | null;
  viewport: string;
  besidePanelOpen: boolean;
};

let lastLanding: StickyLanding | null = null;

export function recordStickyLanding(landing: StickyLanding): void {
  lastLanding = landing;
}

export function getLastStickyLanding(): StickyLanding | null {
  return lastLanding;
}
